<app-loading *ngIf="carInformacionInicial"></app-loading>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <h1 class="titulo-pagina">{{ 'TASASVARIABLES.LBL_TASASVARIABLES' | translate}}</h1>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
      <button type="button" pButton icon="fa fa-plus" (click)="crear()"
              label="{{ 'BTN_AGREGAR' | translate}}"></button>
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')">
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt [value]="lisTasas" selectionMode="single"
               dataKey="idProducto" [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="text-center">{{row.codigo}}</td>
            <td class="text-center">{{row.tasaVariable}}</td>
            <td class="text-center">{{row.diasVigencia}}</td>
            <td class="text-center">{{row.fechaInicioVigencia | date:'dd/MM/yyyy'}}</td>
            <td class="text-center">{{row.fechaFinVigencia | date:'dd/MM/yyyy'}}</td>
            <td class="text-center">{{row.valorTasa}}</td>
            <td class="text-center">{{row.usuarioConfigura}}</td>
            <td class="text-center">{{row.usuarioAprueba}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button btn" icon="fa fa-check" data-toggle="tooltip" *ngIf="botonVisible"
                        title="{{'TASASVARIABLES.BTN_ACTIVAR' | translate}}" pButton (click)="activar(row)"></button>
                <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                        title="{{'BTN_VISUALIZAR' | translate}}" pButton (click)="visualizar(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton (click)="editar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
